import decode from 'jwt-decode';
import auth0 from 'auth0-js';
import Router from 'vue-router';
import axios from 'axios';

const ID_TOKEN_KEY = process.env.CLIENT_ID;
const ACCESS_TOKEN_KEY = process.env.CLIENT_SECRET;
const CLIENT_ID = process.env.CLIENT_ID;
const CLIENT_DOMAIN = process.env.DOMAIN;
const REDIRECT = `${window.location.origin}/callback`;
const SCOPE = 'full_access';
const AUDIENCE = process.env.AUDIENCE;

const auth = new auth0.WebAuth({
  clientID: CLIENT_ID,
  domain: CLIENT_DOMAIN
});

export function login() {
  auth.authorize({
    responseType: 'token id_token',
    redirectUri: REDIRECT,
    audience: AUDIENCE,
    scope: SCOPE
  });
}

const router = new Router({
  mode: 'history'
});

export function getIdToken() {
  return localStorage.getItem(ID_TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY);
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName(name) {
  const match = RegExp(`[#&]${name}=([^&]*)`).exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

// Get and store access_token in local storage
export function setAccessToken() {
  const accessToken = getParameterByName('access_token');
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

// Get and store id_token in local storage
export function setIdToken() {
  const idToken = getParameterByName('id_token');
  localStorage.setItem(ID_TOKEN_KEY, idToken);
}

function getTokenExpirationDate(encodedToken) {
  const token = decode(encodedToken);
  if (!token.exp) {
    return null;
  }

  const date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token);
  return expirationDate < new Date();
}

export function isLoggedIn() {
  const idToken = getIdToken();
  return !!idToken && !isTokenExpired(idToken);
}

export function getTokenDetails() {
  return decode(getAccessToken());
}

export function logout() {
  clearIdToken();
  clearAccessToken();
  router.go('/');
}


export function requireAuth(to, from, next) {
  if (!isLoggedIn()) {
    next({
      path: '/',
      query: {
        redirect: to.fullPath
      }
    });
  } else {
    next();
  }
}

export function createUser(email) {
  const url = `${process.env.api_endpoint}/api/admin`;
  if(!isLoggedIn()) {
    return logout();
  }
  const headers = { Authorization: `Bearer ${getAccessToken()}` };
  const validateStatus = function (status) {
    return (status >= 200) && (status < 500);
  }
  return axios.post(url, { email }, { headers, validateStatus  })
}



//////////////////
// WEBPACK FOOTER
// ./utils/auth.js
// module id = 4swq
// module chunks = 1